import { render, staticRenderFns } from "./err-404.vue?vue&type=template&id=0a7c4bdb&scoped=true&"
import script from "./err-404.vue?vue&type=script&lang=js&"
export * from "./err-404.vue?vue&type=script&lang=js&"
import style0 from "./err-404.vue?vue&type=style&index=0&id=0a7c4bdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7c4bdb",
  null
  
)

export default component.exports